import React, { createContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import LoadingAnimation from "./Assets/LoadingAnimation.gif"

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true); // To manage initial loading state
  const navigate = useNavigate();

  useEffect(() => {
    const token = Cookies.get('accessToken');
    axios.post("/RequestJWTToken/TokenProvider/verifyToken",{
        "registeredAppName":process.env.REACT_APP_REGISTERED_APP_NAME,	
        "accessToken":token
    }).then((res)=>{
        setAuthenticated(true)
    }).catch((err)=>{
        setAuthenticated(false)
    })
    setLoading(false); // Mark loading as complete
  }, []);

  const login = () => {
    setAuthenticated(true);
  };

  const logout = () => {
    setAuthenticated(false);
    Cookies.remove('accessToken');
    navigate('/sign-in');
  };

  if (loading) {
    return <div style={{width:"100vw", height:"100vh",background:"rgba(0, 0, 0, 0.4)",display:'flex',justifyContent:'center',alignItems:"center"}}><img src={LoadingAnimation} alt="" /></div>;
  }

  return (
    <AuthContext.Provider value={{ authenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
